
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("al4VD", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $3izAL = parcelRequire("3izAL");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $is1T6 = parcelRequire("is1T6");


var $jLnA6 = parcelRequire("jLnA6");


var $gWLTH = parcelRequire("gWLTH");


var $8lt1a = parcelRequire("8lt1a");


var $9wGTI = parcelRequire("9wGTI");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");

function $97c789ddabfb1332$var$_defineProperty(e, r, t) {
    return (r = $97c789ddabfb1332$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $97c789ddabfb1332$var$_toPropertyKey(t) {
    var i = $97c789ddabfb1332$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $97c789ddabfb1332$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97c789ddabfb1332$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $97c789ddabfb1332$var$labelContainerStyles = (0, $buxP3.xcss)({
    flex: 2
});
const $97c789ddabfb1332$var$badgeContainerStyles = (0, $buxP3.xcss)({
    paddingLeft: 'space.075'
});
class $97c789ddabfb1332$var$ContentToolsItemClass extends (0, $cozmU.PureComponent) {
    render() {
        const { label: label, onClick: onClick, url: url, id: id, className: className, isDisabled: isDisabled, innerRef: innerRef, testId: testId, onMouseEnter: onMouseEnter, shouldHighlight: shouldHighlight, elemBefore: elemBefore, interactionName: interactionName } = this.props;
        const contentToolsItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onMouseEnter: onMouseEnter,
            onFocus: this.onFocus,
            "data-test-id": id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default // @ts-ignore DropdownItem doesn't declare support for className
        ), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            href: url ?? undefined,
            testId: (testId || id) ?? undefined,
            onClick: onClick,
            isDisabled: isDisabled,
            elemBefore: elemBefore,
            UNSAFE_shouldDisableRouterLink: true,
            interactionName: interactionName
        }, typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97c789ddabfb1332$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            gap: "space.075",
            alignItems: "center",
            xcss: $97c789ddabfb1332$var$labelContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ref: innerRef,
            "data-test-id": "content-item-label",
            dangerouslySetInnerHTML: {
                __html: label.replace(/[0-9]/g, '').replace(/[{()}]/g, '')
            }
        })), label.replace(/\D/g, '').length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $97c789ddabfb1332$var$badgeContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLnA6.default), null, label.replace(/\D/g, ''))) : null) : label));
        if (shouldHighlight) {
            // COMMENTS-6275: When migration gate is on, use new @atlaskit/spotlight API (PopoverProvider + PopoverTarget).
            // New API has no pulse equivalent; we wrap the target so usage is migrated to @atlaskit/spotlight.
            if ((0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                paddingInline: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, contentToolsItem)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                paddingInline: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWLTH.Pulse), {
                radius: 4
            }, contentToolsItem)));
        }
        return contentToolsItem;
    }
    constructor(...args){
        super(...args);
        $97c789ddabfb1332$var$_defineProperty(this, "onFocus", (event)=>{
            const { onMouseEnter: onMouseEnter } = this.props;
            if (onMouseEnter) onMouseEnter(event);
        });
    }
}
$97c789ddabfb1332$var$_defineProperty($97c789ddabfb1332$var$ContentToolsItemClass, "propTypes", {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    testId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    url: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node.isRequired,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    linkComponent: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).elementType,
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    shouldHighlight: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).elementType
});
$97c789ddabfb1332$var$_defineProperty($97c789ddabfb1332$var$ContentToolsItemClass, "defaultProps", {
    onMouseEnter: ()=>{}
});
const $97c789ddabfb1332$export$c2ed13e36e284c55 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97c789ddabfb1332$var$ContentToolsItemClass, {
            innerRef: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
});
$97c789ddabfb1332$export$c2ed13e36e284c55.displayName = 'ContentToolsItem';
module.exports["ContentToolsItem"] = $97c789ddabfb1332$export$c2ed13e36e284c55;

});


//# sourceMappingURL=ContentToolsItem.7403dc53.js.map
